import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterLink, useRouter, RouteLocationRaw } from 'vue-router';
import { localizedPath, basePath, isNeutralPath } from '@/router/paths';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleLink',
  props: {
    to: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();
const { locale } = useI18n();
const localizedTo = computed(() => {
  const resolved = router.resolve(props.to);
  return {
    path: isNeutralPath(resolved.path) ? basePath(resolved.path) : localizedPath(resolved.path, locale.value),
    query: resolved.query,
    hash: resolved.hash,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterLink), { to: localizedTo.value }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["to"]))
}
}

})